import React from "react";

const Mission = () => {
  return (
    <div className="flex flex-col justify-center gap-4 xl:gap-10 xl:mx-24 mt-10">
      <div className="p-6 xl:p-[48px_100px] justify-between items-center bg-white rounded-[24px]  text-justify">
        <h3 className="text-[#493ED3] font-noto-sans-armenian text-[24px] text-center font-semibold leading-normal">
          ԱԶԳԱՅԻՆ ԴՊՐՈՑ
        </h3>
        <h3 className="text-[#493ED3] font-noto-sans-armenian text-[24px] text-center font-semibold leading-normal mb-4">
          Առաքելությունը
        </h3>
        <p className="text-black indent-8 font-noto-sans-armenian text-[18px] font-medium leading-normal">
          <strong>Ազգային կրթությունը</strong> սեփական տեսակի՝ ազգի ինքնության,
          որակների, արժեքային համակարգի, մշակութային ինքնատիպության
          ճանաչողության, պահպանման, տարածման, զարգացման, կատարելագործման,
          անընդհատական արդիականացման, հարակայության ապահովման համընդհանուր և
          ամբողջական համակարգ ու միակ երաշխիքն է։
        </p>
        <p className="text-black indent-8 font-noto-sans-armenian text-[18px] font-medium leading-normal">
          <strong>Ազգային կրթությունը</strong> սեփական տեսակի՝ ազգի
          քաղաքակրթական ինքնատիպության ու առաքելության հետ հաղորդակցվելու միակ
          միջոցն ու գործիքն է, ըստ այդմ, անցյալի ժառանգության, ներկայի
          նպատակադրումների և ապագայի մեջ դրանց իրացվելիության միակ կենսագործուն
          մեխանիզմն է։
        </p>
        <p className="text-black indent-8 font-noto-sans-armenian text-[18px] font-medium leading-normal">
          <strong>Ազգային կրթությունը</strong> հնարավոր է իրացնել միայն
          համապատասխան Ազգային Դպրոցի առկայության դեպքում /վիրտուալ և իրական/։
          Ազգային Դպրոցը Ազգային Կրթության միսն ու արյունն է, որը կենսունակ է
          դարձնելու Հայոց քաղաքակրթամշակութային անցյալ, ներկա, ապագա
          միասնականությունը և ամբողջականությունը, այն վառելանյութն է, որն
          ապահովելու է Հայոց ազգային քաղաքակրթության անընդհատությունը և
          հարակայությունը, ժամանակի այն մեքենան է, որը կազմակերպելու է այդ
          քաղաքակրթական տարածաժամանակային կոորդինատային հարթության ծիրում
          անցյալահայաց, ներկաարար և ապագայատեսիլ ճամփորդությունն ու
          հաղորդակցությունը։
        </p>
        <p className="text-black indent-8 font-noto-sans-armenian text-[18px] font-medium leading-normal">
          <strong>Ազգային Դպրոցը</strong> այն դարբնոցն է, որում կոփվելու և
          թրծվելու են ներկային ու ապագայի սերունդները ազգասեր ու հայրենասեր
          խանդավառ զգացումով, ինքնաճանաչ ու հայրենաճանաչ գիտակցությամբ ու
          իմաստությամբ, ազգանվեր ու հայրենանվեր հոգևոր սրբազան նվիրականությամբ,
          ազգակիր ու հայրենատեր վճռական կամքով, ազգային բովանդակությամբ
          պետականության կերտման ու կայացման, պահպանման ու պաշտպանության,
          ժառանգականության և հարակայության ապահովման խոր, հիմնարար ու
          արհեստավարժ գիտելիքներով և հմտություններով զինված և զինվորագրված։
        </p>
        <p className="text-black indent-8 font-noto-sans-armenian text-[18px] font-medium leading-normal">
          <strong>Ազգային Դպրոցը</strong> ազգային բովանդակությամբ պետականության
          կայացման համար անհրաժեշտ Ազգային առաքինի ու ազնվաբարո, արդար ու
          ճշմարտասեր արժանի ընտրանու ծննդատունն է, որի զավակները որդիական
          խոնարհությամբ և ծնողական հոգատարությամբ կծառայեն Ազգային քաղաքակրթական
          էությունից ու մշակութային ինքնությունից, նպատակադրումներից ու
          առաքելությունից բխող նման Ազգային Պետության կայացմանը։ Ազգային Դպրոցի
          կայացումը ենթադրում է ոչ միայն որակապես նոր Ազգային Կրթակարգ, այլ այս
          ամենին համապատասխան Ազգային Ուսուցիչ, Մանկավարժ, ով այս ամբողջ
          բովանդակությունն իր մեջ կրելով, արժանի կլինի այս նոր կոչմանն ու
          կերպարին և ունակ կլինի կրթելու և դաստիարակելու ազգային ինքնությամբ ու
          արժեորակներով Ուսյալ Սերունդ, Հայ Մարդ, հայոց պետականությանն արժանի
          Հայրենատեր Քաղաքացի և մարդկությանն ու աշխարհին պիտանի Առաքինի Մարդ։
          Ազգային Դպրոցն ու Ազգային Կրթակարգը ենթադրում, նպատակավորում են Հայի
          արժեքային նոր բովանդակության ու ինքնության, որակական ավելի բարձ
          բնույթի ու տեսակի՝ Արարատյան Մարդու կայացում։ Արարատյան Մարդը հայի
          կատարելատիպն է՝ իր մարդկային ու ազգային վեհագույն որակներով ու
          արժեքներով, առաքինությամբ ու բարոյականությամբ, գիտակցությամբ ու
          իմաստությամբ, անձնազոհ նվիրականությամբ, անկոտրում կամքով, անմնացորդ
          ծառայությամբ, անանձնական ու վերանձնական երջանկությամբ,
          Աստվածասիրությամբ ու Արարչաճանաչողությամբ։
        </p>
        <p className="text-black indent-8 font-noto-sans-armenian text-[18px] font-medium leading-normal">
          <strong className="text-[#493ED3]">Արարատյան Մարդը</strong> կոչում է,
          որակ, արժեք, հոմանիշ ու նույնականացում, ցուցիչ ու չափանիշ,
          ընդօրինակման կատարելատիպ, նպատակ ու առաքելություն, որի կայացումը
          Ազգային Դպրոցի ու Ազգային Կրթակարգի սուրբ ու նվիրական Առաքելությունն
          է։
        </p>
      </div>
    </div>
  );
};

export default Mission;
